import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { inject, Injectable } from '@angular/core';
import { RequetService } from './requests.service';
import { catchError, tap } from 'rxjs';
import { IChangeRequestApprovers, IUploadReceipt } from './interface';
import { AddRequestComment, GetApprovers, UploadReceipt } from './action';

export class IProps {
    receipt!: IUploadReceipt | null;
    approvers!: IChangeRequestApprovers[];
    loading!: boolean;
    error!: string | null;
}

@State<IProps>({
    name: 'requests',
    defaults: {
        receipt: null,
        approvers: [],
        loading: false,
        error: null
    }
})
@Injectable()
export class RequestsStore {
    requestsService: RequetService = inject(RequetService);
    private store: Store = inject(Store);

    @Selector()
    static getReceipt(state: IProps) {
        return state.receipt;
    }
    @Selector()
    static getApprovers(state: IProps) {
        return state.approvers;
    }

    @Selector()
    static loading(state: IProps) {
        return state.loading;
    }

    @Action(GetApprovers)
    get(ctx: StateContext<IProps>, action: GetApprovers) {
        const state = ctx.getState();
        ctx.patchState({ loading: true });

        return this.requestsService.getApprovers().pipe(
            tap((res) => {
                ctx.patchState({
                    approvers: res,
                    loading: false
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loading: false,
                    error: err.message
                });
                throw err;
            })
        );
    }

    @Action(UploadReceipt)
    uploadReceipt(ctx: StateContext<IProps>, action: UploadReceipt) {
        return this.requestsService.uploadReceipt(action.input).pipe(
            tap((res) => {
                ctx.patchState({
                    receipt: res
                });
            }),
            catchError((err) => {
                throw err;
            })
        );
    }
    @Action(AddRequestComment)
    addComment(ctx: StateContext<IProps>, action: AddRequestComment) {
        const state = ctx.getState();
        ctx.patchState({ loading: true });

        return this.requestsService.comment(action.input).pipe(
            tap((res) => {
                ctx.patchState({
                    // requests: state.requests?.map((r)=>r.id===action.input.remarkId?{...r,...action.input as any}:r) ,
                    loading: false
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loading: false,
                    error: err.message
                });
                throw err;
            })
        );
    }
}
